import { sessionValidateURL } from '@app/boot';
import { LoadTimeLogger, MARKERS, MEASURES_NAMES } from 'mt-shared';

const performanceLogger: LoadTimeLogger = new LoadTimeLogger();

export function measureValidateCallTime(markEnd: boolean = false): void {
  if (markEnd) window.performance.mark(MARKERS.VALIDATE_CALL_END);
  performanceLogger.measureFromMarker(
    MARKERS.VALIDATE_CALL_START,
    MARKERS.VALIDATE_CALL_END,
    MEASURES_NAMES.VALIDATE_API_TIME,
    { flush: true, clearMarkers: false },
  );
}

export function measureBootToValidateStartDuration(): void {
  performanceLogger.measureFromMarker(
    MARKERS.BOOT_START,
    MARKERS.VALIDATE_CALL_START,
    MEASURES_NAMES.BOOT_START_TO_VALIDATE_START_TIME,
    { flush: true, clearMarkers: false },
  );
}

export function clearValidateCallMarkers(): void {
  if (window.performance.getEntriesByName(MARKERS.VALIDATE_CALL_START).length) {
    window.performance.clearMarks(MARKERS.VALIDATE_CALL_START);
  }
  if (window.performance.getEntriesByName(MARKERS.VALIDATE_CALL_END).length) {
    window.performance.clearMarks(MARKERS.VALIDATE_CALL_END);
  }
}

/**
 * Logs the load time of the index EJS file.
 */
export function logIndexEJSLoadTime(): void {
  const entries: PerformanceEntry[] = window.performance.getEntriesByType('navigation');
  if (!entries?.length) return;
  const firstNavigationEntry: PerformanceEntry = entries[0];
  const loadingTime: number = firstNavigationEntry?.['responseEnd'];
  (window as any).INDEX_EJS_URL = firstNavigationEntry?.['name'];
  performanceLogger.addLog(MEASURES_NAMES.INDEX_EJS_LOADTIME, loadingTime);
  performanceLogger.flushPageLoadTimeLogs([MEASURES_NAMES.INDEX_EJS_LOADTIME]);
}

export function logSessionValidateDetails(): void {
  let sessionValidateAPIResourceDuration: number = -1;
  let sessionValidateNetworkCallStartTime: number = -1;
  let validateGETResponseTime: number = -1;

  const entries: PerformanceEntry[] = window.performance.getEntriesByType('resource').filter(
    (entry: PerformanceEntry) => entry['initiatorType'] === 'fetch' &&
      entry['name']?.includes(sessionValidateURL),
  );

  if (!entries?.length || isNaN(entries?.[0]?.duration)) return;

  const sessionValidateAPIResource: PerformanceEntry = entries?.[0];
  sessionValidateAPIResourceDuration = sessionValidateAPIResource?.['duration'];

  performanceLogger.addLog(MEASURES_NAMES.VALIDATE_GET_API_START_TIME, sessionValidateAPIResourceDuration);
  const logsToFlushManually: string[] = [MEASURES_NAMES.VALIDATE_GET_API_START_TIME];

  const bootStartTime: number = window.performance.getEntriesByName(MARKERS.BOOT_START)?.[0]?.['startTime'];
  if (bootStartTime !== undefined && bootStartTime !== null) {
    sessionValidateNetworkCallStartTime = sessionValidateAPIResource.startTime - bootStartTime;
    performanceLogger.addLog(MEASURES_NAMES.VALIDATE_GET_API_START_TIME, sessionValidateNetworkCallStartTime);

    const validateGETResponseEndMarker: number = window.performance.getEntriesByName(
      MARKERS.VALIDATE_CALL_END)?.[0]?.['startTime'];
    validateGETResponseTime = validateGETResponseEndMarker - bootStartTime;
    performanceLogger.addLog(MEASURES_NAMES.VALIDATE_GET_API_END_TIME, validateGETResponseTime);

    logsToFlushManually.push(MEASURES_NAMES.VALIDATE_GET_API_START_TIME);
    logsToFlushManually.push(MEASURES_NAMES.VALIDATE_GET_API_END_TIME);
  }

  performanceLogger.flushPageLoadTimeLogs([...logsToFlushManually]);

}

export function measureBootToPromiseDuration(): void {
  performanceLogger.measureFromMarker(
    MARKERS.BOOT_START,
    MARKERS.BOOT_TS_PROMISE_ALL_START,
    MEASURES_NAMES.BOOTSTART_PROMISE_ALL_CALL_DURATION,
    {
      flush: true,
      clearMarkers: false,
    },
  );
}

export function measurePromiseAllDuration(): void {
  performanceLogger.measureFromMarker(
    MARKERS.BOOT_TS_PROMISE_ALL_START,
    MARKERS.BOOT_TS_PROMISE_ALL_END,
    MEASURES_NAMES.STATSIG_I18N_SEMANTIC_PROMISE_DURATION,
    {
      flush: true,
      clearMarkers: true,
    },
  );
}

export function measureValidateResponseEventDuration(): void {
  performanceLogger.measureFromMarker(
    MARKERS.VALIDATE_RESPONSE_EVENT_TIMER_START,
    MARKERS.VALIDATE_RESPONSE_EVENT_TIMER_END,
    MEASURES_NAMES.VALIDATE_RESPONSE_EVENT_TIMER, {
      flush: true,
      clearMarkers: true,
    });
}